/** Shared navigation constants. */
// Tab roots — bottom-nav destinations; instant swap (no slide) between these per iOS convention.
export const TAB_ROOTS = new Set(['/', '/menu', '/offer-of-the-day', '/subscriptions', '/cart']);

// Staff portal tab roots (Business Rule #41) — the bottom-tab destinations of
// /staff. Switching BETWEEN these is a tab switch (instant swap / shared
// transition key, shell stays mounted); navigating to a staff detail page
// (run / recipe / exam / incidents) is a hierarchical push and animates.
export const STAFF_TAB_ROOTS = new Set([
  '/staff', '/staff/checklists', '/staff/sops', '/staff/launches',
  '/staff/exams', '/staff/review',
]);
